import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

type PermissionsNoticeBoxProps = {
  message?: string;
  permissions: string[];
  columns?: number;
  variant?: "contained" | "plain";
};

const PermissionsNoticeBox = ({
  message,
  permissions,
  columns = 2,
  variant = "contained",
}: PermissionsNoticeBoxProps) => (
  <Box
    sx={{
      border: variant === "contained" ? "1px solid" : 0,
      borderColor: variant === "contained" ? "primary.main" : "transparent",
      borderRadius: "var(--radius-container)",
      bgcolor: variant === "contained" ? "var(--primary-tint)" : "transparent",
      p: variant === "contained" ? 2 : 0,
    }}
  >
    {message && (
      <Typography
        className="mb-3"
        sx={{ color: "var(--neutral-700)", fontSize: 14, fontWeight: 500 }}
      >
        {message}
      </Typography>
    )}

    <Grid container spacing={1}>
      {permissions.map((permission) => (
        <Grid key={permission} size={{ xs: 12, sm: 12 / columns }}>
          <Box className="d-flex align-items-center">
            <CheckCircleOutlineIcon
              sx={{ color: "var(--status-success)", fontSize: 16, mr: 1 }}
            />
            <Typography sx={{ color: "var(--neutral-600)", fontSize: 13 }}>
              {permission}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default PermissionsNoticeBox;
